import React from 'react';
import { Outlet } from 'react-router-dom';
import { AdminAuthProvider } from '@/context/AdminAuthContext';
import AdminLayout from './AdminLayout';

/**
 * Wraps all /admin routes with auth + staff shell.
 * Child panels are declared as nested routes in App.js.
 */
export default function AdminApp() {
  return (
    <AdminAuthProvider>
      <AdminLayout>
        <Outlet />
      </AdminLayout>
    </AdminAuthProvider>
  );
}
